/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MonitoringControllerDtoNftBoxListNftBoxData model module.
 * @module model/MonitoringControllerDtoNftBoxListNftBoxData
 * @version 1.0
 */
class MonitoringControllerDtoNftBoxListNftBoxData {
    /**
     * Constructs a new <code>MonitoringControllerDtoNftBoxListNftBoxData</code>.
     * @alias module:model/MonitoringControllerDtoNftBoxListNftBoxData
     */
    constructor() { 
        
        MonitoringControllerDtoNftBoxListNftBoxData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MonitoringControllerDtoNftBoxListNftBoxData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MonitoringControllerDtoNftBoxListNftBoxData} obj Optional instance to populate.
     * @return {module:model/MonitoringControllerDtoNftBoxListNftBoxData} The populated <code>MonitoringControllerDtoNftBoxListNftBoxData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MonitoringControllerDtoNftBoxListNftBoxData();

            if (data.hasOwnProperty('nftInventoryNo')) {
                obj['nftInventoryNo'] = ApiClient.convertToType(data['nftInventoryNo'], 'Number');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('minted')) {
                obj['minted'] = ApiClient.convertToType(data['minted'], 'Boolean');
            }
            if (data.hasOwnProperty('metadataUrl')) {
                obj['metadataUrl'] = ApiClient.convertToType(data['metadataUrl'], 'String');
            }
            if (data.hasOwnProperty('boxType')) {
                obj['boxType'] = ApiClient.convertToType(data['boxType'], 'Number');
            }
            if (data.hasOwnProperty('boxRarity')) {
                obj['boxRarity'] = ApiClient.convertToType(data['boxRarity'], 'Number');
            }
            if (data.hasOwnProperty('boxBlessedFlag')) {
                obj['boxBlessedFlag'] = ApiClient.convertToType(data['boxBlessedFlag'], 'Boolean');
            }
            if (data.hasOwnProperty('boxImageUrl')) {
                obj['boxImageUrl'] = ApiClient.convertToType(data['boxImageUrl'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('nftMintingNo')) {
                obj['nftMintingNo'] = ApiClient.convertToType(data['nftMintingNo'], 'Number');
            }
            if (data.hasOwnProperty('mintedAt')) {
                obj['mintedAt'] = ApiClient.convertToType(data['mintedAt'], 'Date');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('valid')) {
                obj['valid'] = ApiClient.convertToType(data['valid'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MonitoringControllerDtoNftBoxListNftBoxData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MonitoringControllerDtoNftBoxListNftBoxData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['metadataUrl'] && !(typeof data['metadataUrl'] === 'string' || data['metadataUrl'] instanceof String)) {
            throw new Error("Expected the field `metadataUrl` to be a primitive type in the JSON string but got " + data['metadataUrl']);
        }
        // ensure the json data is a string
        if (data['boxImageUrl'] && !(typeof data['boxImageUrl'] === 'string' || data['boxImageUrl'] instanceof String)) {
            throw new Error("Expected the field `boxImageUrl` to be a primitive type in the JSON string but got " + data['boxImageUrl']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * @member {Number} nftInventoryNo
 */
MonitoringControllerDtoNftBoxListNftBoxData.prototype['nftInventoryNo'] = undefined;

/**
 * @member {Number} nftUid
 */
MonitoringControllerDtoNftBoxListNftBoxData.prototype['nftUid'] = undefined;

/**
 * @member {Boolean} minted
 */
MonitoringControllerDtoNftBoxListNftBoxData.prototype['minted'] = undefined;

/**
 * @member {String} metadataUrl
 */
MonitoringControllerDtoNftBoxListNftBoxData.prototype['metadataUrl'] = undefined;

/**
 * @member {Number} boxType
 */
MonitoringControllerDtoNftBoxListNftBoxData.prototype['boxType'] = undefined;

/**
 * @member {Number} boxRarity
 */
MonitoringControllerDtoNftBoxListNftBoxData.prototype['boxRarity'] = undefined;

/**
 * @member {Boolean} boxBlessedFlag
 */
MonitoringControllerDtoNftBoxListNftBoxData.prototype['boxBlessedFlag'] = undefined;

/**
 * @member {String} boxImageUrl
 */
MonitoringControllerDtoNftBoxListNftBoxData.prototype['boxImageUrl'] = undefined;

/**
 * @member {Date} createdAt
 */
MonitoringControllerDtoNftBoxListNftBoxData.prototype['createdAt'] = undefined;

/**
 * @member {Number} nftMintingNo
 */
MonitoringControllerDtoNftBoxListNftBoxData.prototype['nftMintingNo'] = undefined;

/**
 * @member {Date} mintedAt
 */
MonitoringControllerDtoNftBoxListNftBoxData.prototype['mintedAt'] = undefined;

/**
 * @member {Number} accountNo
 */
MonitoringControllerDtoNftBoxListNftBoxData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
MonitoringControllerDtoNftBoxListNftBoxData.prototype['email'] = undefined;

/**
 * @member {Boolean} valid
 */
MonitoringControllerDtoNftBoxListNftBoxData.prototype['valid'] = undefined;






export default MonitoringControllerDtoNftBoxListNftBoxData;

